<template>
    <div class="div-top">
        <el-row>
            <el-col :span="5">
                <img class="topLogoImage" src="../assets/images/logo.png"/>
            </el-col>
            <el-col :span="3" :offset=2>
                <el-link type="primary" href="/#/">首页</el-link>
            </el-col>
            <el-col :span="3">
                <el-link type="primary" href="/#/Navigition">网站导航</el-link>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name : 'Top'
}
</script>
<style scoped>
    .div-top{
        background-color:  rgba(255, 255, 255, 0.9);
    }
    .topLogoImage{
        width: 100%;
    }
    .el-link{
        font-size: 20px;
        line-height: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Top.vue